import request from 'api/request';

export default function createTicketRoute({ courseId, isFollowup, answers }) {
  return request({
    url: '/tickets',
    method: 'POST',
    data: { courseId, isFollowup, answers },
  });
}
